import { CEQuizResponse } from '../Shared/scriptts/interfaces';
export const NumberOfQuestions = 32;
export const CEResponseClientName = 'CEResponsesData';
export const CEResponses: CEQuizResponse = getCEResponses();

// init functions
document.addEventListener('DOMContentLoaded', evt => {
    initHome();
    bindHomeEvents();
});

function initHome() {
    const responseLength = CEResponses.responses.length;
    const responseId = CEResponses.responseId;

    if (responseLength < 1) {
        document.querySelector<HTMLElement>('#startButton')?.classList.remove('hidden');
    }
    else if (responseId < 1 || responseLength !== NumberOfQuestions) {
        document.querySelector<HTMLElement>('#restartButton')?.classList.remove('hidden');
        document.querySelector<HTMLElement>('#continueButton')?.classList.remove('hidden');
        document.querySelector<HTMLElement>('#quizStatusMessage')?.classList.remove('hidden');
    }
    else if (responseId > 0 && responseLength === NumberOfQuestions) {
        document.querySelector<HTMLElement>('#restartButton')?.classList.remove('hidden');
        document.querySelector<HTMLElement>('#resultsButton')?.classList.remove('hidden');
        document.querySelector<HTMLElement>('#quizStatusMessage')?.classList.remove('hidden');
        const element = document.getElementById("quizStatusMessage");
        if (element) {
            element.innerHTML = "You've already completed the quiz.";
        }
    }
}

// event handlers
function bindHomeEvents() {
    document.querySelector<HTMLElement>('#startButton')?.addEventListener('click', reStartButtonClicked);
    document.querySelector<HTMLElement>('#restartButton')?.addEventListener('click', reStartButtonClicked);
    document.querySelector<HTMLElement>('#resultsButton')?.addEventListener('click', resultsButtonClicked);
    document.querySelector<HTMLElement>('#continueButton')?.addEventListener('click', continueButtonClicked);
}

function reStartButtonClicked() {
    initCEResponses();  
    location.href = '/careerexplorer/quiz';
}

function resultsButtonClicked() {
    location.href = '/careerexplorer/results/' + CEResponses.responseId;
}

function continueButtonClicked() {
    CEResponses.currentQuestionIndex = (CEResponses.responses.length > 0) ? CEResponses.responses.length : 0;
    setCEResponses(CEResponses);
    location.href = '/careerexplorer/quiz';
}

export function initCEResponses() {
    setCEResponses(<CEQuizResponse>{ currentQuestionIndex: 0, resultsPageIndex: 0, responseId: 0, responses: [] });
}

function getCEResponses(): CEQuizResponse {
    let rawResponse: string | null = localStorage.getItem(CEResponseClientName);
    if (rawResponse == null) {
        initCEResponses();
    }
    return <CEQuizResponse>JSON.parse(localStorage.getItem(CEResponseClientName) || '{}');
}

export function setCEResponses(ceResponse: CEQuizResponse) {
    localStorage.setItem(CEResponseClientName, JSON.stringify(ceResponse));
} 

